/* eslint-disable */ 

export const storeModuleNames = {
    MAP_FOR_ROUTES: 'mapForRoutes',
    ROUTES_PARAMS_STORE: 'routesParamsStore',
}

export const operators = {
    MY_AGENT: [226, 299],
};

export const productTypes = {
    ALL: 'all',
    TOUR_OFFER: 'tourOffer',
    RAILWAY_TOUR: 'railwayTour',
    HOTEL_OFFER: 'hotelOffer',
};

export const POST_MESSAGE_DOMAINS = new Set(['tinkoff.mobapp', 't-bank.mobapp']);
